import * as types from './types'
import placementApi from '../api'

export const actions = {
    async [types.PLACEMENT_FETCH]({commit}, data = null) {
        commit(types.PLACEMENT_SET_LOADING, true)
        const response = await placementApi.all(data)
        commit(types.PLACEMENT_OBTAIN, response.data.data)
        commit(types.PLACEMENT_META, response.data.meta)
        commit(types.PLACEMENT_SET_LOADING, false)
    },
}
